import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { useLanguage } from './LanguageContext';
const HERO_BG = 'https://cdn.magicpatterns.com/uploads/c53BGBVDNrRXmxNTiMDtgZ/davies16.webp';
export function HeroSection() {
  const {
    t
  } = useLanguage();
  return <section className="relative h-screen w-full flex items-center justify-center overflow-hidden" data-id="element-154">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-155">
        <img src={HERO_BG} alt="Canada Celebration" className="w-full h-full object-cover object-[center_20%]" fetchPriority="high" decoding="sync" data-id="element-156" />
        <div className="absolute inset-0 bg-gradient-to-b from-canada-black/80 via-canada-black/60 to-canada-black" data-id="element-157"></div>
      </div>

      {/* Content */}
      <div className="container relative z-10 mx-auto px-6 md:px-12 flex flex-col items-center text-center mt-20" data-id="element-158">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="mb-4 inline-block" data-id="element-159">
          <span className="bg-canada-red/20 border border-canada-red text-canada-gold px-4 py-1.5 rounded-full font-oswald uppercase tracking-widest text-sm font-medium backdrop-blur-sm" data-id="element-160">
            {t('hero.badge')}
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-4xl sm:text-5xl md:text-7xl lg:text-8xl font-oswald font-bold uppercase leading-tight tracking-tight mb-6 max-w-5xl" data-id="element-161">
          {t('hero.title1')} <br className="hidden md:block" data-id="element-162" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-canada-gold to-yellow-200" data-id="element-163">
            {t('hero.title2')}
          </span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="text-base md:text-xl text-gray-300 max-w-2xl mb-10 font-light" data-id="element-164">
          {t('hero.subtitle')}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.8
      }} className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto" data-id="element-165">
          <a href="#matches" className="bg-canada-gold hover:bg-white text-canada-black px-8 py-4 rounded-full font-oswald uppercase tracking-wider font-bold transition-all duration-300 flex items-center justify-center min-w-[200px] min-h-[44px]" data-id="element-166">
            {t('hero.cta1')}
          </a>
          <a href="#team" className="bg-transparent border border-white/30 hover:border-white hover:bg-white/10 text-white px-8 py-4 rounded-full font-oswald uppercase tracking-wider font-bold transition-all duration-300 flex items-center justify-center min-w-[200px] min-h-[44px]" data-id="element-167">
            {t('hero.cta2')}
          </a>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 1,
      delay: 1.5
    }} className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 z-10" data-id="element-168">
        <span className="font-oswald text-xs uppercase tracking-widest text-gray-400" data-id="element-169">
          {t('hero.scroll')}
        </span>
        <motion.div animate={{
        y: [0, 10, 0]
      }} transition={{
        repeat: Infinity,
        duration: 1.5,
        ease: 'easeInOut'
      }} data-id="element-170">
          <ChevronDown className="text-canada-gold" size={24} data-id="element-171" />
        </motion.div>
      </motion.div>
    </section>;
}